import axios from 'axios'
import { SALVAR_IMAGENS_INFORMAR_ENTREGA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function salvarImagensInformarEntrega (idEncomenda, idEmpresa, imagens, observacao) {
  const url = `${URL}/encomendas/${idEncomenda}/empresa/${idEmpresa}/imagens/informar-entrega`;
  return dispatch => axios.post(url, imagens, observacao, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: SALVAR_IMAGENS_INFORMAR_ENTREGA,
        payload: response
      })
  );
}